//Erbjudanderabatt
import intervals from "../components/ProductPage/entrepreneur_insurance_intervals";

const discountFactor = 0.8;
const FTG_factor = 0.9996;

//Calculations for "Egendom"

function calculateEgendom(business, businessType, revenue) {

    const startPremie = 1800;

    const base_factor_property = revenue.basfaktor_egendom;

    const entrepreneur_factor = businessType.entreprenadfaktor;

    let result = startPremie * base_factor_property * entrepreneur_factor * FTG_factor * discountFactor;

    return result;
}


function calculateAnsvar(business, businessType, revenue) {


    const startPremie = 5000;


    const basfaktor_ansvar = revenue.basfaktor_ansvar;

    const ansvarsfaktor = businessType.ansvarsfaktor;


    let result = startPremie * basfaktor_ansvar * ansvarsfaktor * FTG_factor * discountFactor;

    return result;
}


function calculateKris(basBelopp) {

    let result = 5 * (basBelopp * 0.25) / 1000 * FTG_factor * discountFactor;

    return result;
}


export function calculateBasbeloppFromAmount(amount) {


    //1 Basbelopp 2019=46.500 kr
    // const basbelopp = 46500;

    // let amountOfBB = Math.ceil(amount / basbelopp);

    let basbelopp = 2;
    let treshold = 90000;
    // if (amount <= 90000) return intervals[0].treshold;
    if (amount <= 90000) return basbelopp;

    for (let i in intervals) {
        // let basbelopp = intervals[i].prisbasbelopp;
        if (intervals[i].treshold > amount){
            basbelopp = intervals[i].prisbasbelopp;
            treshold = intervals[i].treshold;
            break;
        }
    }

    return basbelopp;
}

export function getClosestThreshold(value){
    if(value <= 90000) return intervals[0].treshold;

    for (var i in intervals) {
        var treshold = intervals[i].treshold;
        if(treshold > value) return treshold;
    }

    return null;
}


export function calculateSmaffPrice(state, basbelopp, productState) {

    const {currentBusiness, currentBusinessType, selectedRevenue} = state;

    let egendomspremie = 46500 * 0.001 * (basbelopp + 4) * currentBusinessType.egendomsfaktor * FTG_factor * discountFactor;
    let avbrott = egendomspremie * 0.2 * FTG_factor;
    let ansvar = 46500 * currentBusinessType.ansvarsfaktor * 0.01 * FTG_factor * discountFactor;

    let tjansteresa = 1752 * FTG_factor * discountFactor;

    if (productState.selectedSmaffPackage == 1) tjansteresa = 0;

    let dataskydd = 695;

    let result = egendomspremie + avbrott + ansvar + dataskydd + tjansteresa;

    return Math.round(result);
}

export function calculateSmaffPriceWithoutDiscount(state, basbelopp, productState) {

    const {currentBusiness, currentBusinessType, selectedRevenue} = state;

    let egendomspremie = 46500 * 0.001 * (basbelopp + 4) * currentBusinessType.egendomsfaktor * FTG_factor;
    let avbrott = egendomspremie * 0.2 * FTG_factor;
    let ansvar = 46500 * currentBusinessType.ansvarsfaktor * 0.01 * FTG_factor;

    let tjansteresa = 1752 * FTG_factor;

    if (productState.selectedSmaffPackage == 1) tjansteresa = 0;

    let dataskydd = 695;

    let result = egendomspremie + avbrott + ansvar + dataskydd + tjansteresa;

    return Math.round(result);
}

export function getSmaffCalculationJSON(state, basbelopp, productState) {

    const { currentBusinessType, selectedRevenue} = state;


    let egendomspremie = 46500 * 0.001 * (basbelopp + 4) * currentBusinessType.egendomsfaktor * FTG_factor * discountFactor;
    let avbrott = egendomspremie * 0.2 * FTG_factor;
    let ansvar = 46500 * currentBusinessType.ansvarsfaktor * 0.01 * FTG_factor * discountFactor;

    let tjansteresa = 1752 * FTG_factor * discountFactor;

    if (productState.selectedSmaffPackage == 1) tjansteresa = 0;

    let dataskydd = 695;

    let result = egendomspremie + avbrott + ansvar + dataskydd + tjansteresa;

    return {
        "prisbasbelopp": basbelopp,
        "egendomspremie": egendomspremie,
        "avbrott": avbrott,
        "ansvar": ansvar,
        "tjansteresa": tjansteresa,
        "dataskydd": dataskydd,
        // "arbetspremie": arbete,
        // "hjalpmedelspremie": hjalpmedel,
        // "ansvarspremie": ansvar,
        // "dataskydd": 695,
        // "kris": kris,
        "FTG06": FTG_factor,
        "entreprenadfaktor": currentBusinessType.entreprenadfaktor,
        "ansvarsfaktor": currentBusinessType.ansvarsfaktor,
        "egendomsfaktor": currentBusinessType.egendomsfaktor,
        "erbjudandefaktor": discountFactor,
        "basfaktor_ansvar": selectedRevenue.basfaktor_ansvar,
        "Erbjudandefaktor": discountFactor,
    };
    // return Math.round(result);
}
